export const FETCH_ACCOUNT_STATUS_REQUEST = 'FETCH_ACCOUNT_STATUS_REQUEST'
export const FETCH_ACCOUNT_STATUS_SUCCESS = 'FETCH_ACCOUNT_STATUS_SUCCESS'
export const FETCH_ACCOUNT_STATUS_FAILURE = 'FETCH_ACCOUNT_STATUS_FAILURE'